module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "custom-class": "dialog-wrapper scroll-dialog",
      "title": _vm.dialogTitle,
      "close-on-click-modal": false,
      "modal-append-to-body": false
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "flex-row-center"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.dialogVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.clickEditDone
          }
        }, [_vm._v("确定")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("\n    屏蔽总开关 "), _c('span', {
    staticClass: "optional-tip"
  }, [_vm._v("（选填，可多选）")])]), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机系统"
    }
  }, [_c('el-select', {
    staticClass: "campus-select",
    attrs: {
      "multiple": "",
      "placeholder": "可多选，已选不可重复"
    },
    model: {
      value: (_vm.systemBlock),
      callback: function($$v) {
        _vm.systemBlock = $$v
      },
      expression: "systemBlock"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "HarmonyOS",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Android",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "iOS",
      "value": "1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "item-title"
  }, [_vm._v("\n    版本号屏蔽 "), _c('span', {
    staticClass: "optional-tip"
  }, [_vm._v("（选填）")])]), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true
    }
  }, _vm._l((_vm.versionBlock), function(item, index) {
    return _c('div', {
      key: 'ver-' + index,
      staticClass: "margin-bottom-10"
    }, [_c('el-form-item', {
      attrs: {
        "label": "手机系统"
      }
    }, [_c('el-select', {
      model: {
        value: (item.osType),
        callback: function($$v) {
          _vm.$set(item, "osType", $$v)
        },
        expression: "item.osType"
      }
    }, [_c('el-option', {
      attrs: {
        "label": "HarmonyOS",
        "value": "2"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "Android",
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "iOS",
        "value": "1"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "版本号"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "不限制"
      },
      model: {
        value: (item.version),
        callback: function($$v) {
          _vm.$set(item, "version", $$v)
        },
        expression: "item.version"
      }
    })], 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.clickAddVersion
      }
    }, [_vm._v("添加")]) : _vm._e(), _vm._v(" "), (index != 0) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          return _vm.clickDeleteVersion(index)
        }
      }
    }) : _vm._e()], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "item-title"
  }, [_vm._v("应用校区 "), _c('span', {
    staticClass: "required-tip"
  }, [_vm._v("*")])]), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "校区范围"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.campusType),
      callback: function($$v) {
        _vm.campusType = $$v
      },
      expression: "campusType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("全量")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("部分")])], 1)], 1), _vm._v(" "), (_vm.campusType === '1') ? _c('el-form-item', {
    attrs: {
      "label": "屏蔽校区"
    }
  }, [_c('el-select', {
    staticClass: "campus-select",
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "选填，可添加多个"
    },
    model: {
      value: (_vm.unidListA),
      callback: function($$v) {
        _vm.unidListA = $$v
      },
      expression: "unidListA"
    }
  }, _vm._l((_vm.campusDataSource), function(c) {
    return _c('el-option', {
      key: c.value,
      attrs: {
        "label": c.label,
        "value": c.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.campusType === '2') ? _c('el-form-item', {
    attrs: {
      "label": "生效校区"
    }
  }, [_c('el-select', {
    staticClass: "campus-select",
    attrs: {
      "multiple": "",
      "placeholder": "必填，可添加多个"
    },
    model: {
      value: (_vm.unidListB),
      callback: function($$v) {
        _vm.unidListB = $$v
      },
      expression: "unidListB"
    }
  }, _vm._l((_vm.campusDataSource), function(c) {
    return _c('el-option', {
      key: c.value,
      attrs: {
        "label": c.label,
        "value": c.value
      }
    })
  }), 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17707a1a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/SystemConfig/SystemConfig/Components/DigitalYuedongAdShield.vue
// module id = 953
// module chunks = 0